<template>
  <el-button v-if="canRedFlush(record)" type="text" size="small" class="red-flush-button" :loading="busy" @click="redFlush">
    红冲
  </el-button>
</template>

<script>
import api from '@/api/tenantInvoice'
import { notifyApiError } from '@/utils/apiError'
import { canRedFlush, hasValue } from '../tenantInvoiceModel'

export default {
  name: 'InvoiceRedFlushButton',
  props: { record: { type: Object, required: true } },
  data () {
    return { busy: false, active: true }
  },
  beforeDestroy () {
    this.active = false
  },
  methods: {
    canRedFlush,
    async redFlush () {
      if (this.busy || !canRedFlush(this.record)) return
      const { id, fphm, managerId, tenantId } = this.record
      this.busy = true
      try {
        await this.$confirm(`确认红冲发票 ${fphm || id}？`, '发票红冲', {
          type: 'warning',
          confirmButtonText: '确认红冲',
          cancelButtonText: '取消'
        })
      } catch {
        this.busy = false
        return
      }

      const current = () => this.active && String(this.record.id) === String(id)
      try {
        if (!current()) return
        const { data } = await api.detail(id)
        if (!current()) return
        const sameScope = data &&
          (!hasValue(data.managerId) || String(data.managerId) === String(managerId)) &&
          (!hasValue(data.tenantId) || String(data.tenantId) === String(tenantId))
        if (!sameScope || !canRedFlush({ id, type: data.type, status: data.status })) {
          this.$message.warning('该发票当前不可红冲，请查看最新状态')
          this.$emit('refresh')
          return
        }
        await api.redFlush(id)
        if (!current()) return
        this.$message.success('红冲请求已提交')
        this.$emit('refresh')
      } catch (error) {
        if (current()) notifyApiError(error, '红冲请求失败')
      } finally {
        this.busy = false
      }
    }
  }
}
</script>

<style scoped>
.red-flush-button { color: #f56c6c; }
</style>
